<div *ngIf="toastPackage" role="alertdialog" class="toast-message" (swipe)="swipeEvent($event)">
    <div [innerHTML]="toastPackage?.message"></div>
    <a class="mat-button float-right" color="primary" *ngIf="toastPackage.title" (click)="action()">{{toastPackage.title}}</a>
</div>
